<div class="footer-container">
    <div class="footer-container-inner">
        <div class="footer-title">
            стать автором
        </div>
        <div class="footer-workspace">
            <div class="footer-workspace-text">
                Публикацией карты проект не завершается. Итоговая цель – собрать максимально
                возможную информацию об участии железнодорожников Северной магистрали
                в Великой Отечественной войне. Поэтому, если у вас есть факты, истории, архивные
                фотографии, то мы будем рады ознакомиться с ними и разместить в проекте.
            </div>
            <div class="footer-workspace-el">
                <div class="footer-workspace-el-title">
                    ВАШЕ ИМЯ
                </div>
                <input [(ngModel)]="formData.name" placeholder="Введите ваше полное имя">
            </div>
            <div class="footer-workspace-el">
                <div class="footer-workspace-el-title">
                    ЭЛЕКТРОННАЯ ПОЧТА
                </div>
                <input [(ngModel)]="formData.email" placeholder="Введите вашу электронную почту">
            </div>
            <div class="footer-workspace-el">
                <div class="footer-workspace-el-title">
                    СООБЩЕНИЕ
                </div>
                <textarea #messageTextarea
                          [(ngModel)]="formData.message"
                          placeholder="Расскажите про вашу тематику"
                          (input)="onInput(messageTextarea)">
                </textarea>
            </div>
            <div class="footer-workspace-el">
                <div class="footer-workspace-el-title">
                    ФАЙЛЫ
                </div>
                <app-upload-files (emitFiles)="getFiles($event)"></app-upload-files>
            </div>
            <div class="footer-workspace-el">
                <div class="footer-workspace-el-button" (click)="submitForm()">
                    {{ submitted ? 'Сообщение отправлено' : 'отправить' }}
                </div>
            </div>
            <div style="padding-top: 80px">
                2026 © Северная железная дорога – филиал ОАО «РЖД»
            </div>
        </div>
    </div>
</div>
